import { keys as parentKeys } from '@copro/api';
import type { DocumentType } from '../../../types';
import type { DocumentIndexingListParams } from '../types/documentIndexing';

export type DocumentFilters = {
  subTopicId?: string;
  providerId?: string;
};

export type DocumentSortField = 'name' | 'type' | 'created_at';
export type SortDirection = 'asc' | 'desc';

export type AllDocumentsParams = {
  search?: string;
  type?: DocumentType | null;
  sortField: DocumentSortField;
  sortDirection: SortDirection;
  page: number;
  pageSize: number;
};

export const keys = {
  documents: [...parentKeys.all, 'documents'] as const,

  getDocuments: (filters: DocumentFilters, page: number, pageSize: number) =>
    [...keys.documents, 'getDocuments', filters, { page, pageSize }] as const,

  getAllDocuments: (spaceId: string, params: AllDocumentsParams) =>
    [...keys.documents, 'getAllDocuments', spaceId, params] as const,

  getDocumentsBySubTopicId: (subTopicId: string) => [...keys.documents, 'getDocumentsBySubTopicId', subTopicId],

  getDocumentsByProviderId: (providerId: string) => [...keys.documents, 'getDocumentsByProviderId', providerId],

  getDocumentTypes: (spaceId: string) => [...keys.documents, 'getDocumentTypes', spaceId] as const,

  documentIndexing: (spaceId: string) => [...keys.documents, 'documentIndexing', spaceId] as const,

  getDocumentIndexings: (spaceId: string, params: DocumentIndexingListParams) =>
    [...keys.documentIndexing(spaceId), 'list', params] as const,

  getDocumentIndexingStats: (spaceId: string) =>
    [...keys.documentIndexing(spaceId), 'stats'] as const,

  getDocumentContent: (documentId: string) =>
    [...keys.documents, 'content', documentId] as const,
};

